var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveBanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4287 12.5714H24.5716V17.7143H23.4287V12.5714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4577 8.00688C19.4487 8.00226 19.4387 7.99995 19.4286 8.00001C19.4184 7.99982 19.4084 8.00238 19.3995 8.00745L13.1538 11.4131L25.6744 11.4286L19.4577 8.00688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1431 12.5714H22.2859V17.7143H21.1431V12.5714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93257 1.71431H15.9246C16.1253 1.71412 16.3111 1.60875 16.4143 1.43662L17.2766 0H5.58057L6.44288 1.43656C6.546 1.60869 6.73188 1.71412 6.93257 1.71431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0624 27.3143C11.7114 27.5482 11.26 27.5697 10.8884 27.3703C10.5167 27.1709 10.285 26.7829 10.2858 26.3612V24.5715H9.71435C8.45198 24.5715 7.42867 23.5481 7.42867 22.2858V6.85712C7.42867 5.59475 8.45204 4.57144 9.71435 4.57144H21.1429V2.28569C21.1429 1.02337 20.1195 0 18.8572 0H18.6092L17.3943 2.02513C17.0832 2.53994 16.5261 2.85531 15.9246 2.85713H6.9326C6.33104 2.85531 5.77404 2.53994 5.46292 2.02513L4.24804 0H4.00004C2.73767 0 1.71436 1.02337 1.71436 2.28569V29.7143C1.71436 30.9766 2.73767 32 4.00004 32H18.8572C20.1195 32 21.1429 30.9766 21.1429 29.7143V24.5714H16.1714L12.0624 27.3143ZM18.2857 29.7143C18.2857 30.0299 18.0299 30.2857 17.7143 30.2857H5.14292C4.82736 30.2857 4.57148 30.0299 4.57148 29.7143C4.57148 29.3987 4.82729 29.1429 5.14292 29.1429H17.7144C18.0299 29.1429 18.2857 29.3987 18.2857 29.7143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1427 5.71432H9.71416C9.08298 5.71432 8.57129 6.22601 8.57129 6.8572V22.2858C8.57129 22.917 9.08298 23.4286 9.71416 23.4286H10.857C11.1726 23.4286 11.4285 23.6845 11.4285 24.0001V26.3612L15.6828 23.5246C15.7767 23.462 15.887 23.4286 15.9999 23.4286H29.1428C29.774 23.4286 30.2857 22.917 30.2857 22.2858V6.85714C30.2855 6.22595 29.7739 5.71432 29.1427 5.71432ZM26.857 20.5715C26.857 21.2026 26.3453 21.7143 25.7141 21.7143H13.1427C12.5115 21.7143 11.9999 21.2026 11.9999 20.5715V18.8571C11.9999 18.2259 12.5115 17.7143 13.1427 17.7143V12.568C12.6186 12.5613 12.1644 12.2034 12.0353 11.6954C11.904 11.1863 12.1408 10.6538 12.6067 10.4103L18.8518 7.00339C19.2117 6.80995 19.6446 6.80995 20.0044 7.00339L26.2507 10.4103C26.7169 10.6537 26.9537 11.1863 26.8222 11.6954C26.6934 12.2038 26.2386 12.562 25.7142 12.568V17.7143C26.3453 17.7143 26.857 18.2259 26.857 18.8571V20.5715H26.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8574 18.8571H20.5717H18.286H16.0003H13.7146H13.1431H13.1426L13.1431 20.5714H25.7146V18.8571H25.1431H22.8574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2856 12.5714H15.4285V17.7143H14.2856V12.5714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 12.5714H19.9998V17.7143H18.8569V12.5714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5713 12.5714H17.7142V17.7143H16.5713V12.5714Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_1102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveBanking);
export default __webpack_public_path__ + "static/media/inactiveBanking.73d65eb642d11fa6382ff75cfd5c8083.svg";
export { ForwardRef as ReactComponent };